import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, Box, Container, Typography } from '@material-ui/core';
import IframeMap from '../../widgets/iframe-map/IframeMap.js';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';

var useStyles = makeStyles(function (theme) {
  return {
    mt7: {
      marginTop: theme.spacing(7)
    }
  };
});
var EmbedMap = function EmbedMap(_ref) {
  var title = _ref.title,
    mapOpts = _ref.mapOpts,
    backgroundColor = _ref.backgroundColor;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: backgroundColor || "#ffffff",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: "md",
    disableGutters: true
  }, /*#__PURE__*/React__default.createElement(Box, {
    pt: 7,
    pb: 7,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    component: "h3",
    variant: "h3"
  }, title), /*#__PURE__*/React__default.createElement(IframeMap, {
    className: classes.mt7,
    url: mapOpts === null || mapOpts === void 0 ? void 0 : mapOpts.url,
    placeId: mapOpts === null || mapOpts === void 0 ? void 0 : mapOpts.placeId,
    keyword: mapOpts === null || mapOpts === void 0 ? void 0 : mapOpts.keyword,
    coordinates: mapOpts === null || mapOpts === void 0 ? void 0 : mapOpts.coordinates,
    width: (isExtraSmallScreen() ? "100%" : mapOpts === null || mapOpts === void 0 ? void 0 : mapOpts.width) || "100%",
    height: mapOpts === null || mapOpts === void 0 ? void 0 : mapOpts.height
  }))));
};
EmbedMap.propTypes = {
  title: PropTypes__default.string,
  backgroundColor: PropTypes__default.string,
  mapOpts: PropTypes__default.shape({
    url: PropTypes__default.string.isRequired,
    keyword: PropTypes__default.string,
    width: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
    height: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
    placeId: PropTypes__default.string,
    coordinates: PropTypes__default.shape({
      lon: PropTypes__default.number,
      lat: PropTypes__default.number
    })
  })
};

export { EmbedMap as default };
//# sourceMappingURL=EmbedMap.js.map
